import restApiDispatcher from "@/store/utils/api-dispatcher";
import { Favourite } from "@/models";

const createFavourite = (context, params) =>
  restApiDispatcher(context, {
    resource: Favourite,
    storeKey: "favourite",
    loadingKey: "favouriteLoading",
    action: "create",
    silent: true,
    message: "Added to favorites.",
    params
  });

const createFavouriteForAthlete = (context, params) =>
  restApiDispatcher(context, {
    resource: Favourite,
    storeKey: "favourite",
    loadingKey: "favouriteLoading",
    action: "create",
    silent: true,
    message: "Added to favorites",
    params
  });

const deleteFavourite = (context, params) =>
  restApiDispatcher(context, {
    resource: Favourite,
    storeKey: "favourite",
    loadingKey: "favouriteLoading",
    action: "unfavourite",
    commitType: "delete",
    silent: true,
    message: "Removed from favorites.",
    params
  });

const getFavourites = (context, params) =>
  restApiDispatcher(context, {
    resource: Favourite,
    storeKey: "favourites",
    loadingKey: "favouritesLoading",
    action: "index",
    meta: "meta",
    params
  });

const checkFavourite = (context, params) =>
  restApiDispatcher(context, {
    resource: Favourite,
    storeKey: "checkedFavourite",
    loadingKey: "checkedFavouriteLoading",
    action: "checkFavourite",
    commitType: "show",
    params
  });

const deleteLocalFavouriteDate = (context, params) =>
  context.commit("DELETE_FAVOURITE", params);

const setCheckedFavourite = context => context.commit("SET_CHECKED_FAVOURITE");

const unsetCheckedFavourite = context =>
  context.commit("UNSET_CHECKED_FAVOURITE");

export default {
  createFavourite,
  createFavouriteForAthlete,
  deleteFavourite,
  getFavourites,
  deleteLocalFavouriteDate,
  checkFavourite,
  setCheckedFavourite,
  unsetCheckedFavourite
};
